// app
export const APP_INITIALIZATION = 'APP_INITIALIZATION'
export const RESET_CONCENT = 'RESET_CONCENT'
export const SHOW_LOADER = 'SHOW_LOADER'
export const HIDE_LOADER = 'HIDE_LOADER'
export const SOUND_STATUS_RECEIVED = 'SOUND_STATUS_RECEIVED'
export const MUSIC_STATUS_RECEIVED = 'MUSIC_STATUS_RECEIVED'
export const SHOW_NUDGES = 'SHOW_NUDGES'
export const HIDE_NUDGES = 'HIDE_NUDGES'
export const SHOW_MODALS = 'SHOW_MODALS'
export const HIDE_MODALS = 'HIDE_MODALS'
export const TOGGLE_NUDGE = 'TOGGLE_NUDGE'
export const SET_SERIAL_NUMBER = 'SET_SERIAL_NUMBER'
export const SET_LOCATION_PERMISSION_STATUS = 'SET_LOCATION_PERMISSION_STATUS'
export const SHOW_LOCATION_MODAL = 'SHOW_LOCATION_MODAL'
export const HIDE_LOCATION_MODAL = 'HIDE_LOCATION_MODAL'
export const NOTIFICATION_COUNT_UPDATE = 'NOTIFICATION_COUNT_UPDATE'
export const HIDE_FORCE_UPDATE = 'HIDE_FORCE_UPDATE'
export const SET_FIRST_DEPOSIT_MODAL = 'SET_FIRST_DEPOSIT_MODAL'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_RG_BLOCK = 'SET_RG_BLOCK'
export const HERO_VIDEO_PLAYED_ONCE = 'HERO_VIDEO_PLAYED_ONCE'
export const DISMISS_SPLASH_SCREEN = 'DISMISS_SPLASH_SCREEN'
export const SET_DASHBOARD_DYNAMIC_DATA = 'SET_DASHBOARD_DYNAMIC_DATA'
export const UPDATE_REFERRAL_PROGRESS_CARDS = 'UPDATE_REFERRAL_PROGRESS_CARDS'
export const CHANGE_APP_STATE = 'CHANGE_APP_STATE'

// user
export const REFERRAL_CODE_RECEIVED = 'REFERRAL_CODE_RECEIVED'
export const REFERRAL_CAMPAIGN_RECEIVED = 'REFERRAL_CAMPAIGN_RECEIVED'
export const STORE_BONUS_ANIMATION_DATA = 'STORE_BONUS_ANIMATION_DATA'
export const REFERRAL_BONUS_ALERT_DATA = 'REFERRAL_BONUS_ALERT_DATA'
export const STORE_ON_BOARDING_REFERRAL_DATA = 'STORE_ON_BOARDING_REFERRAL_DATA'
export const SET_IS_FEEDBACK_SUBMITTED = 'SET_IS_FEEDBACK_SUBMITTED'
export const ON_BOARDING_COMPLETED = 'ON_BOARDING_COMPLETED'
export const USER_LOGOUT = 'USER_LOGOUT'
export const FETCHING_USER_DETAILS = 'FETCHING_USER_DETAILS'
export const USER_DETAILS_COMPLETE_UPDATED = 'USER_DETAILS_COMPLETE_UPDATED'
export const USER_FROM_BANNER_STATE = 'USER_FROM_BANNER_STATE'
export const USER_DATA_UPDATED = 'USER_DATA_UPDATED'
export const BANNER_SCREEN_DATA = 'BANNER_SCREEN_DATA'
export const SHOW_DELINK_MODAL = 'SHOW_DELINK_MODAL'
export const SHOW_GENERIC_POPUP = 'SHOW_GENERIC_POPUP'
export const CLOSE_GENERIC_POPUP = 'CLOSE_GENERIC_POPUP'
export const HIDE_DELINK_MODAL = 'HIDE_DELINK_MODAL'
export const USER_DP_UPDATED = 'USER_DP_UPDATED'
export const JUSPAY_RES = 'JUSPAY_RES'
export const SET_PAYMENT_CONFIG = 'SET_PAYMENT_CONFIG'
export const DELINK_POPUP = 'DELINK_POPUP'
export const USER_DATA_FOR_SNL = 'USER_DATA_FOR_SNL'
export const SET_LOCATION_STATE = 'SET_LOCATION_STATE'
export const SET_VIP_CONFIG = 'SET_VIP_CONFIG'
export const SET_CHECK_NUDGE_ON_HOMESCREEN = 'SET_CHECK_NUDGE_ON_HOMESCREEN'
export const SET_INBOUND_TOOLTIP = 'SET_INBOUND_TOOLTIP'
export const UPDATE_ON_BOARDING_CURR_STEPS_INDEX = 'UPDATE_ON_BOARDING_CURR_STEPS_INDEX'
export const STORE_ON_BOARDING_STEPS = 'STORE_ON_BOARDING_STEPS'
export const SET_HOMEPAGE_BANNER_LIST = 'SET_HOMEPAGE_BANNER_LIST'
export const SET_HOME_PAGE_CAROUSEL_LIST = 'SET_HOME_PAGE_CAROUSEL_LIST'

//play online
export const UPDATE_MY_FILTERS = 'UPDATE_MY_FILTERS'
export const TOURNAMENTS_RECEVIED = 'TOURNAMENTS_RECEVIED'
export const TOURNAMENTS_BANNER_FILTER = 'TOURNAMENTS_BANNER_FILTER'
export const SHOW_GAME_JOINED_BOTTOMSHEET = 'SHOW_GAME_JOINED_BOTTOMSHEET'
export const SHOW_COUNTDOWN_TIMER_BOTTOMSHEET = 'SHOW_COUNTDOWN_TIMER_BOTTOMSHEET'
export const ALL_FILTERS_RECEIVED = 'ALL_FILTERS_RECEIVED'
export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS'
export const TOURNAMENT_STARTING = 'TOURNAMENT_STARTING'
export const APP_LOADED = 'APP_LOADED'
export const IS_FIRST_LAUNCH = 'IS_FIRST_LAUNCH'
export const UPDATE_REGISTRATION_COUNT = 'UPDATE_REGISTRATION_COUNT'
export const UPDATE_MTT_REGISTRATION_COUNT = 'UPDATE_MTT_REGISTRATION_COUNT'
export const MT_TOURNAMENT_STARTING = 'MT_TOURNAMENT_STARTING'
export const MT_REMOVE_TOURNAMENT_FROM_STARTED_LIST = 'MT_REMOVE_TOURNAMENT_FROM_STARTED_LIST'
export const SET_PAYOUT_MODES = 'SET_PAYOUT_MODES'
export const ADD_TOURNAMENT_UNABLE_TO_MATCH_MAP = 'ADD_TOURNAMENT_UNABLE_TO_MATCH_MAP'
export const ON_ROOM_READY = 'ON_ROOM_READY'
export const SNL_UNITY_INVOKED = 'SNL_UNITY_INVOKED'
export const SHOW_DGP_GAMEPLAY_EXP = 'SHOW_DGP_GAMEPLAY_EXP'
export const REMOVE_SNL_INFO = 'REMOVE_SNL_INFO'
export const STORE_SNL_TOURNAMENT_INFO = 'STORE_SNL_TOURNAMENT_INFO'
export const FOREGROUND_UNITY_LAUNCH = 'FOREGROUND_UNITY_LAUNCH'
export const REMOVE_WIDGET_LIST = 'REMOVE_WIDGET_LIST'

export const SET_GAME_USER_ID = 'SET_GAME_USER_ID'
export const DISCOUNTED_FEE_DATA = 'DISCOUNTED_FEE_DATA'
export const DISCOUNTED_FEE_CONFIG = 'DISCOUNTED_FEE_CONFIG'
export const GST_MULTIPLIER_FACTOR = 'GST_MULTIPLIER_FACTOR'

export const ACADEMY_CONFIG_DATA = 'ACADEMY_CONFIG_DATA'

// ludoboard
export const LB_PLAYER_JOIN_TABLE = 'LB_PLAYER_JOIN_TABLE'
export const LB_UPDATE_PLAYER_SI_MAP = 'LB_UPDATE_PLAYER_SI_MAP'
export const LB_UPDATE_TABLE_INFO = 'LB_UPDATE_TABLE_INFO'
export const LB_ROUND_TIMER_STARTED = 'LB_ROUND_TIMER_STARTED'
export const LB_TOGGLE_COIN_ANIMATION = 'LB_TOGGLE_COIN_ANIMATION'
export const LB_USER_TURN_STARTED = 'LB_USER_TURN_STARTED'
export const LB_SHOW_SKIP_BOX = 'LB_SHOW_SKIP_BOX'
export const LB_HIDE_SKIP_BOX = 'LB_HIDE_SKIP_BOX'
export const LB_START_DICE_ANIMATION = 'LB_START_DICE_ANIMATION'
export const LB_STOP_DICE_ANIMATION = 'LB_STOP_DICE_ANIMATION'
export const LB_START_BOUNCE_ANIMATION = 'LB_START_BOUNCE_ANIMATION'
export const LB_STOP_BOUNCE_ANIMATION = 'LB_STOP_BOUNCE_ANIMATION'
export const LB_SHOW_TRIPLE_SIX_ANIMATION = 'LB_SHOW_TRIPLE_SIX_ANIMATION'
export const LB_HIDE_TRIPLE_SIX_ANIMATION = 'LB_HIDE_TRIPLE_SIX_ANIMATION'
export const LB_TOGGLE_LAST_MOVE = 'LB_TOGGLE_LAST_MOVE'
export const LB_LEAVE_TABLE = 'LB_LEAVE_TABLE'
export const LB_MOVE_USER_TOKEN = 'LB_MOVE_USER_TOKEN'
export const LB_FINISH_MOVE_USER_TOKEN = 'LB_FINISH_MOVE_USER_TOKEN'
export const LB_KILL_USER_TOKEN = 'LB_KILL_USER_TOKEN'
export const LB_FINISH_KILL_USER_TOKEN = 'LB_FINISH_KILL_USER_TOKEN'
export const LB_SHOW_SMOKE_ANIMATION = 'LB_SHOW_SMOKE_ANIMATION'
export const LB_HIDE_SMOKE_ANIMATION = 'LB_HIDE_SMOKE_ANIMATION'
export const LB_SHOW_POINTS_ANIMATION = 'LB_SHOW_POINTS_ANIMATION'
export const LB_HIDE_POINTS_ANIMATION = 'LB_HIDE_POINTS_ANIMATION'
export const LB_SET_GAME_TIMER = 'LB_SET_GAME_TIMER'
export const LB_RESET_GAME_STATE = 'LB_RESET_GAME_STATE'
export const LB_SHOW_INTERNET_ICON = 'LB_SHOW_INTERNET_ICON'
export const LB_HIDE_INTERNET_ICON = 'LB_HIDE_INTERNET_ICON'
export const LB_SET_PLAYER_TCOUNT = 'LB_SET_PLAYER_TCOUNT'
export const LB_SHOW_WRONG_TURN_ALERT = 'LB_SHOW_WRONG_TURN_ALERT'
export const LB_RESET_GAMEPLAY = 'LB_RESET_GAMEPLAY'
export const LB_USER_PROFILE_SET = 'LB_USER_PROFILE_SET'
export const LB_USER_PROFILE_FOLLOW = 'LB_USER_PROFILE_FOLLOW'
export const LB_STOP_TURN_TIMER = 'LB_STOP_TURN_TIMER'
export const INTERNET_CONNECTIVITY = 'INTERNET_CONNECTIVITY'
export const SET_RANK_DATA = 'SET_RANK_DATA'
export const LB_SHOW_GAME_TIME_NUDGE = 'LB_SHOW_GAME_TIME_NUDGE'
export const LB_SHOW_GAME_START_NUDGE = 'LB_SHOW_GAME_START_NUDGE'
export const LB_HIDE_GAME_START_NUDGE = 'LB_HIDE_GAME_START_NUDGE'
export const LB_SHOW_GAME_END_NUDGE = 'LB_SHOW_GAME_END_NUDGE'
export const LB_HIDE_GAME_END_NUDGE = 'LB_HIDE_GAME_END_NUDGE'
export const LB_SET_SHOW_TAKE_HOME_NUDGE = 'LB_SET_SHOW_TAKE_HOME_NUDGE'
export const LB_SET_KUKARI_MOVE_CONFIG = 'LB_SET_KUKARI_MOVE_CONFIG'
export const LB_SET_SCORE_FLY_ANIMATION_CONFIG = 'LB_SET_SCORE_FLY_ANIMATION_CONFIG'
export const LB_RESET_SCORE_FLY_ANIMATION_CONFIG = 'LB_RESET_SCORE_FLY_ANIMATION_CONFIG'
export const LB_SET_SKIP_COUNT_FOR_NUDGE = 'LB_SET_SKIP_COUNT_FOR_NUDGE'
export const LB_SET_TOKEN_CUT_CN = 'LB_SET_TOKEN_CUT_CN'
export const LB_SET_REACH_HOME_CN = 'LB_SET_REACH_HOME_CN'
export const LB_SET_SAFE_CN = 'LB_SET_SAFE_CN'
export const LB_RESET_ALL_CN = 'LB_RESET_ALL_CN'
export const LB_SET_IS_PRIZEPOOL_TOOLTIP_VISIBLE = 'LB_SET_IS_PRIZEPOOL_TOOLTIP_VISIBLE'
export const LB_SET_IS_TNC_BS_VISIBLE = 'LB_SET_IS_TNC_BS_VISIBLE'
export const LB_START_TIME_BANK_TIMER = 'LB_START_TIME_BANK_TIMER'
export const LB_STOP_TIME_BANK_TIMER = 'LB_STOP_TIME_BANK_TIMER'
export const LB_UPDATE_TIME_BANK_TIME_LEFT = 'LB_UPDATE_TIME_BANK_TIME_LEFT'
export const LB_NX_SHOW_KUKARI_SCORE = 'LB_NX_SHOW_KUKARI_SCORE'
export const LB_NX_HIDE_KUKARI_SCORE = 'LB_NX_HIDE_KUKARI_SCORE'
export const LB_NX_SHOW_SCORE_REVEAL_ANIMATION = 'LB_NX_SHOW_SCORE_REVEAL_ANIMATION'
export const LB_NX_HIDE_SCORE_REVEAL_ANIMATION = 'LB_NX_HIDE_SCORE_REVEAL_ANIMATION'
export const LB_SET_SHOW_EXTRA_MOVE_NUDGE = 'LB_SET_SHOW_EXTRA_MOVE_NUDGE'
export const LB_SET_IS_SKIP_TOOLTIP_VISIBLE = 'LB_SET_IS_SKIP_TOOLTIP_VISIBLE'
// Paw
export const SET_USER_STATE_API = 'SET_USER_STATE_API'
export const SET_LIVE_CONTEST_API = 'SET_LIVE_CONTEST_API'
export const SET_SUBMIT_ANSWER_API = 'SET_SUBMIT_ANSWER_API'
export const SET_CORRECT_ANSWER_API = 'SET_CORRECT_ANSWER_API'
export const SET_NEXT_CONTEST_API = 'SET_NEXT_CONTEST_API'
export const SET_COLLECT_REWARDS_API = 'SET_COLLECT_REWARDS_API'
export const SET_REWARD_HISTORY_API = 'SET_REWARD_HISTORY_API'
export const SET_IS_API_LOADER_VISIBLE = 'SET_IS_API_LOADER_VISIBLE'
export const SET_IS_TRANSITION_LOADER_VISIBLE = 'SET_IS_TRANSITION_LOADER_VISIBLE'
export const SET_USER_RESPONSE = 'SET_USER_RESPONSE'
export const UPDATE_USER_RESPONSE = 'UPDATE_USER_RESPONSE'
export const SET_WALLET_DIMENSIONS = 'SET_WALLET_DIMENSIONS'
export const OPEN_COLLECT_NOW_MODAL = 'OPEN_COLLECT_NOW_MODAL'
export const SET_CONTEST_CONFIG = 'SET_CONTEST_CONFIG'
export const SET_EXPIRING_SOON = 'SET_EXPIRING_SOON'
export const SET_REWARD_HISTORY_CLICKED_ONCE = 'SET_REWARD_HISTORY_CLICKED_ONCE'
export const CLEAR_PAW_REDUCER_DATA = 'CLEAR_PAW_REDUCER_DATA'
export const COLLECT_ANIMATION_COMPLETED_WITHOUT_NEXT_CONTEST = 'COLLECT_ANIMATION_COMPLETED_WITHOUT_NEXT_CONTEST'
export const COLLECT_ANIMATION_COMPLETED_WITH_NEXT_CONTEST = 'COLLECT_ANIMATION_COMPLETED_WITH_NEXT_CONTEST'
export const CLOSE_COLLECT_NOW_MODAL = 'CLOSE_COLLECT_NOW_MODAL'
export const RESET_API_STATUS = 'RESET_API_STATUS'
export const IS_AUTH_API_RESPONSE_STATUS = 'IS_AUTH_API_RESPONSE_STATUS'
export const SHOW_GOOGLE_LOGIN_MODAL = 'SHOW_GOOGLE_LOGIN_MODAL'
export const HIDE_GOOGLE_LOGIN_MODAL = 'HIDE_GOOGLE_LOGIN_MODAL'